module.exports = __webpack_public_path__ + "img/projectbaner.16c4159a.png";